import { Modal } from "@/components/General/Modal/modal";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

export type ConfirmModalComponentProps = {
    open: boolean;
    text: string;
    confirmButtonText: string;
    onClose: () => void;
    onConfirm: () => Promise<void>;
};

const ConfirmModalComponent = ({
    open,
    text,
    confirmButtonText,
    onClose,
    onConfirm
}: ConfirmModalComponentProps) => {
    const { t } = useGranite();

    const handleConfirm = () => {
        onConfirm?.().then(() => {
            onClose?.();
        });
    };

    return (
        <Modal
            autoFocus={true}
            centered={true}
            open={open}
            setOpen={onClose}
            title={t("modal.confirm.title")}
            withFooter={true}
            size="sm"
            confirmButtonText={confirmButtonText}
            onConfirm={handleConfirm}
        >
            {text}
        </Modal>
    );
};

export { ConfirmModalComponent };
